"use client"

// src/index.ts
import { getColorModeValue, useColorMode, useTheme } from "@yamada-ui/core";
import { getBreakpointValue, useBreakpoint } from "@yamada-ui/use-breakpoint";
import { isArray, isObject } from "@yamada-ui/utils";
import { useMemo } from "react";
var useValue = (value) => {
  const { theme } = useTheme();
  const breakpoint = useBreakpoint();
  const { colorMode } = useColorMode();
  return useMemo(() => {
    return getValue(value)(theme, colorMode, breakpoint);
  }, [value, theme, colorMode, breakpoint]);
};
var getValue = (value) => (theme, colorMode, breakpoint) => {
  var _a;
  if (isObject(value)) {
    const computedValue = getBreakpointValue(value)(theme, breakpoint);
    if (isArray(computedValue)) {
      const [light, dark] = computedValue;
      return getColorModeValue(light, dark)(colorMode);
    } else {
      return computedValue;
    }
  } else if (isArray(value)) {
    const [light, dark] = value;
    const computedValue = getColorModeValue(light, dark)(colorMode);
    if (isObject(computedValue)) {
      if ((_a = theme.__breakpoints) == null ? void 0 : _a.isResponsive(computedValue)) {
        return getBreakpointValue(computedValue)(theme, breakpoint);
      } else {
        return computedValue;
      }
    } else {
      return computedValue;
    }
  } else {
    return value;
  }
};
export {
  getValue,
  useValue
};
//# sourceMappingURL=index.mjs.map